import Loading from "components/common/Loading";
import { useHttpUtil } from "context/HttpContext";
import { useEffect, useRef, useState } from "react"
import CustomImage from "components/common/CustomImage";

// Mockups 产品
export default function Mockups(props: { onImageClick: Function, type?: number}){
    const {type = 4, onImageClick} = props ;

    const [ list, setList] = useState<ProductTypeLib[]>([]);
    const [ sonTypeList, setSonTypeList ] = useState<ProductTypeLib[]>();
    const [ searchList, setSearchList ]= useState<ProductLib[]>();

    const [ searchForm, setSearchForm ]= useState<SearchForm>({
        id : '',
        pageSize: 40,
        currentPage: 1
    });

    const [ page, setPage ]= useState<Page>();

    const [ isLoading, setIsLoading ]= useState<boolean>(false);
    const [ isListLoading, setIsListLoading ]= useState<boolean>(false);
    const [ keyword, setKeyword] = useState<string>();

    const [ checkedType, setCheckedType ] = useState<ProductTypeLib>();

    const [ showTags, setShowTags ] = useState<Tag[]>();
    const [ tagTitles, setTagTitles ]= useState<string[]>();

    const [ modalWidth, setModalWidth] = useState<number>(1200);

    const [ sonTypeScrollInfo, setSonTypeScrollInfo ]= useState<SonTypeScroll>({
        isShow : false,
        page : 0,
        totalPage: 0
    });

    const contentElement = useRef<HTMLDivElement>(null);
    const listElement = useRef<HTMLDivElement>(null);
    const sonTypeListElement = useRef<HTMLDivElement>(null);

    const httpUtil = useHttpUtil();
    

    useEffect(() => {
        let bodyWidth = document.body.clientWidth;
        if(bodyWidth < 1280) bodyWidth += 30 ;
        contentElement.current && setModalWidth(bodyWidth - contentElement.current?.getBoundingClientRect().width - 100)
        initList();
    }, [  ])

    useEffect(() => {
        if(!checkedType) return ;
        initList();
    },[ checkedType ])

    useEffect(() => {
        if(sonTypeListElement.current){
            const listWidth = sonTypeListElement.current?.scrollWidth;
            const listParentWidth = sonTypeListElement.current.parentElement?.offsetWidth as number;
            if(listWidth > listParentWidth){
                setSonTypeScrollInfo({
                    isShow: true,
                    isAllowNext: true,
                    page: 0,
                    totalPage: Math.floor(listWidth / (listParentWidth * 0.8))
                })
            }else{
                setSonTypeScrollInfo({
                    isShow: false,
                    page: 0
                })
            }
            sonTypeListElement.current.style.transform = `translateX(0)`
        }
    },[ sonTypeList ])

    const scrollSonType = (step?: number) => {
        if(sonTypeListElement.current){
            let page = sonTypeScrollInfo.page ;
            page += (step || 1) ;
            let isAllowPrev = page > 0, isAllowNext = page < (sonTypeScrollInfo.totalPage as number) ;
            const listParentWidth = sonTypeListElement.current.parentElement?.offsetWidth as number;
            let transx = 0 ;
            if(isAllowPrev && isAllowNext){
                transx = listParentWidth * -0.8 * page
            }else if(!isAllowNext){
                transx = listParentWidth - sonTypeListElement.current.scrollWidth - 40;
            }
            sonTypeListElement.current.style.transform = `translateX(${transx}px)`
            setSonTypeScrollInfo({
                ...sonTypeScrollInfo,
                page,
                isAllowPrev,
                isAllowNext
            })
        }
    }

    // 切二级分类（左侧）
    const changeProductType = (product: ProductTypeLib) => {
        setCheckedType(product);
        setSearchForm({
            ...searchForm,
            id: '',
            currentPage: 1,
            keyword : '',
            tags: ['','']
        })
        setTagTitles(['','']);
        if(product.id.split('/')[0] === 'apparel'){
            setShowTags([...ClothTags]);
        }else setShowTags([...ProductTags])
    }


    // 切三级分类
    const choiceSonType = (productType: ProductTypeLib | undefined) => {
        const _searchForm = {...searchForm, currentPage: 1};
        _searchForm.id = productType ? productType.id : '' ;
        setSearchForm(_searchForm);
    }

    // 选择产品图
    const changeProduct = async(p: ProductLib) => {
        setCheckedType(undefined) ; // 隐藏
        onImageClick(p.url);
    }

    const handleKeyDown = (e: any) => {
        if(e.key == 'Enter'){
            setSearchForm(({
                ...searchForm,
                keyword: keyword,
                currentPage: 1
            }))

            // search(true);
        }
    }
    
    const initList = async () => {
        const params : any = { type  }
        if(checkedType){
            params.id = checkedType.id;
        }else{
            setList([]);
            setIsLoading(true);
        }
        const resData = await httpUtil.post('/biz/product/mockup/list',params);
        if(resData.errCode === 0){
            if(checkedType){
                setSonTypeList(resData.data);
                return ;
            }
            setList(resData.data)
            setIsLoading(false);
        }
    }


    useEffect(() => {
        if(checkedType){
            // listElement.current && listElement.current.scrollTo({
            //     top: 0,
            //     behavior: 'smooth'
            // })
            // setTimeout(() => search(), 200)
            search();
        }
        
    },[ checkedType, searchForm ])

    const search = async () => {
        listElement.current && listElement.current.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
        setIsListLoading(true);
        // setSearchList([]);

        const params : any = { 
            ...searchForm,
            type
        }
        if(!params.keyword) params.id = searchForm.id || checkedType?.id ;
        const resData = await httpUtil.post('/biz/product/mockup/slist', params);
        if(resData.errCode === 0){
            const data = resData.data ;
            setSearchList(data.records);
            setPage({
                current : data.current,
                total: data.pages,
                isLeftMore: data.pages > 7 && data.current > 5 || data.pages > 6 && data.current > 4,
                isRightMore : data.pages > 7 && (data.current < data.pages - 3) || data.pages > 6 && (data.current < data.pages - 4)
            })
            return setIsListLoading(false);
        }
    }

    const hideController = () => {
        controlTag(null, -1);
    }
    const closeArea = () => {
        setCheckedType(undefined);
    }

    useEffect(() => {
        window.addEventListener('click', hideController);
        return () => {
            window.removeEventListener('click', hideController);
        }
    },[checkedType])

    const contolerPage = (curr: number) => {
        if(searchForm.currentPage === curr || curr < 1 || page && curr > page.total) return ;
        setSearchForm(({
            ...searchForm,
            currentPage: curr
        }))
    }

    const controlTag = (event: React.MouseEvent | null, index: number) => {
        event && event.stopPropagation();
        if(!showTags) return ;
        const tags = [...showTags];
        for(let i = 0, len = tags.length ;i < len; i ++){
            const tag = tags[i];
            if(i === index) tag.isShow = !tag.isShow;
            else tag.isShow = false 
        }
        setShowTags(tags);
    }

    const choiceTag = (item: TagItem, index: number) => {
        const tags = searchForm.tags || ['',''] ;
        tags[index] = item.value ;
        setSearchForm(({
            ...searchForm,
            currentPage: 1,
            tags
        }))
        const _tagTitles = tagTitles && [...tagTitles] || [];
        _tagTitles[index] = item.name ;
        setTagTitles(_tagTitles);
    }


    return (
        <div className="absolute z-[10007] h-full top-[0px] shadow-lg bg-[#FFFFFF] xl:w-[320px] xl:left-[100px] w-[200px] left-[70px]" ref={contentElement}  >
            <div className="relative flex flex-col h-full w-full p-[10px] xl:p-[20px] overflow-y-auto z-[10001]  bg-[#FFFFFF]" onClick={() => setCheckedType(undefined)}>
                {
                    <p className="medium-txt font-medium">Mockup categories</p>
                }
                
                {
                    !isLoading ?
                        <div className="flex flex-col gap-[15px] xl:gap-[30px] mt-[15px] xl:mt-[30px] ">
                            {
                                list && list.map((product: ProductTypeLib) => (
                                    <div key={product.id} className="flex flex-col gap-[10px] xl:gap-[20px]">
                                        <p className="medium-txt font-[500]">{product.name}</p>
                                        <div className="grid grid-cols-2 gap-[5px] xl:gap-[10px]">
                                            {
                                                product.sonList && product.sonList.map((sproduct: ProductTypeLib) => (
                                                    <div className={`cursor-pointer ${checkedType?.id === sproduct.id ? 'rounded-[8px]': ' '} ${checkedType?.id === sproduct.id && 'border-[2px] border-[#14A5FA] p-[5px] '}`} key={sproduct.id} onClick={(e) => { e.stopPropagation(); changeProductType(sproduct)}}>
                                                        <div className="group aspect-square flex items-center">
                                                            <CustomImage loading="lazy" src={sproduct.url} className={`max-w-full max-h-full rounded-[6px] group-hover:hidden`} />
                                                            <CustomImage loading="lazy" src={sproduct.url.replace('.jpg','-mockup.jpg')} className={`max-w-full max-h-full rounded-[6px] hidden group-hover:block`} />
                                                        </div>
                                                        <div className="flex items-center py-[10px]" >
                                                            <span className="font-semibold truncate small-txt">{sproduct.name}</span>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                            
                    :
                        <div className="mt-[80px] text-center">
                            <Loading className="!pb-[5px]"/>
                            <p>Loading, please wait...</p>
                        </div>
                }
            </div>
            {
                checkedType ?
                    <div className="absolute left-[200px] pl-[20px] py-[20px] pr-[20px] top-[0px] xl:left-[320px] h-[100%] w-[1300px] flex gap-[20px] bg-[#000000]/[0.5]" style={{
                        width : modalWidth
                    }}>
                        <CustomImage src="/icon/icon-close.png" className="absolute z-[10] top-[30px] right-[35px] w-[30px] h-[30px] cursor-pointer" onClick={closeArea} />
                        <div className="w-full h-full bg-[#FFFFFF] py-[5px] rounded-[10px] relative">
                            <div className="absolute top-[25px] left-[-13px] w-[25px] h-[25px] rotate-45 bg-[#FFFFFF]"></div>
                            
                            <div className="flex flex-col h-full py-[20px] px-[10px] ">
                                <div className="px-[5px] flex gap-[50px]">
                                    <p className="text-[20px] xl:text-[24px] font-medium">{checkedType.name} Mockups</p>
                                    <div className="flex items-center relative">
                                        <input type="text" placeholder="Search for mockups" 
                                            className="py-[8px] xl:py-[10px] pr-[15px] pl-[35px] xl:pl-[45px] border focus:border-[#14A5FA] w-[300px] xl:w-[400px] outline-none rounded-[10px] "
                                            value={keyword} 
                                            onChange={(e) => setKeyword(e.target.value)}
                                            onKeyDown={handleKeyDown}/>
                                        <CustomImage src="/icon/icon-search.png" className="absolute left-[10px] xl:left-[15px] top-[50%] translate-y-[-10px] w-[20px] h-[20px]" />
                                    </div>
                                </div>
                                <div className="flex items-center pt-[30px] gap-[35px]">
                                    <div className="relative grow overflow-hidden">
                                        {
                                            sonTypeScrollInfo.isShow && sonTypeScrollInfo.isAllowPrev && 
                                            <>
                                                <span className="absolute z-[2] left-[0px] w-[80px] h-[40px] top-[1px] " style={{
                                                    background: 'linear-gradient(270deg, #fff0, #fff 52%)'
                                                }}></span>
                                                <span className="absolute z-[3] left-[0px] w-[40px] h-[40px] top-[0px] flex items-center justify-center bg-[#ffffff] cursor-pointer rounded-r-[50%]"
                                                    onClick={() => scrollSonType(-1)}>
                                                    <span className="w-full h-full hover:bg-[#E7F7FF] rounded-[50%] flex items-center justify-center"><CustomImage src="/icon/icon-layer-right.png" className="w-[17px] h-[17px] rotate-[180deg]" /></span>
                                                </span>
                                            </>
                                        }
                                        <div className={`flex items-center gap-[10px] ${sonTypeScrollInfo.isAllowNext && 'pr-[35px]'} ${sonTypeScrollInfo.isAllowPrev && 'pl-[35px]'} transition-transform	`} ref={sonTypeListElement}>
                                            <span className={`block px-[30px] py-[8px] cursor-pointer small-txt rounded-[20px]  ${!searchForm.id && 'bg-[#E7F7FF]' || 'border hover:border-[#FFFFFF] border-[#D9D9D9]'}`}
                                                onClick={() => choiceSonType(undefined)}>All</span>
                                            {
                                                sonTypeList?.map((type: ProductTypeLib) => (
                                                    <span key={type.id} className={`whitespace-nowrap block px-[30px] py-[8px] cursor-pointer small-txt rounded-[20px]  hover:bg-[#E7F7FF] ${searchForm.id === type.id && 'bg-[#E7F7FF]' || 'border hover:border-[#FFFFFF] border-[#D9D9D9]'}`}
                                                        onClick={() => choiceSonType(type)}>{type.name}</span>
                                                ))
                                            }
                                        </div>
                                        {
                                            sonTypeScrollInfo.isShow && sonTypeScrollInfo.isAllowNext &&
                                            <>
                                                <span className="absolute z-[2] right-[0px] w-[80px] h-[40px] top-[0px] " style={{
                                                    background: 'linear-gradient(270deg, #fff 52%, #fff0)'
                                                }}></span>
                                                <span className="absolute z-[3] right-[0px] w-[40px] h-[40px] top-[0px] flex items-center justify-center bg-[#ffffff] cursor-pointer rounded-l-[50%]"
                                                    onClick={() => scrollSonType()}>
                                                    <span className="w-full h-full hover:bg-[#E7F7FF] rounded-[50%] flex items-center justify-center"><CustomImage src="/icon/icon-layer-right.png" className="w-[17px] h-[17px]" /></span>
                                                </span>
                                            </>
                                            
                                        }
                                    </div>
                                    <div className="flex gap-[10px] items-center">
                                        {
                                            showTags?.map((tagItem: Tag, index: number) => (
                                                <div className="relative max-w-[120px] p-[10px] pr-[37px] cursor-pointer" key={tagItem.title} onClick={(event: React.MouseEvent) => controlTag(event, index)}>
                                                    <span className="block w-full small-txt font-[500] truncate overflow-hidden">{searchForm?.tags && searchForm?.tags[index] && tagTitles && tagTitles[index] || tagItem.title}</span>
                                                    <CustomImage src="/icon/icon-layer-right.png"
                                                        className={`absolute right-[10px] top-[12px] w-[17px] h-[17px] ${ tagItem.isShow && 'rotate-[90deg]' } `} />
                                                    {
                                                        tagItem.isShow && 
                                                        <div className={`absolute flex flex-col gap-[15px] top-[40px] ${index == 0 ? 'left-[0]' : 'right-[10px]'} w-[180px] p-[10px] bg-[#FFFFFF] rounded-[6px] shadow-box`}>
                                                            {
                                                                tagItem.list.map((item: TagItem) => (
                                                                    <span key={tagItem.title + '_' + item.value} 
                                                                        className={`small-txt px-[15px] py-[10px] hover:bg-[#E7F7FF] ${ searchForm?.tags && searchForm?.tags[index] == item.value && 'bg-[#E7F7FF]'} `} 
                                                                        onClick={() => choiceTag(item, index)}>{item.name}</span>
                                                                ))
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                                {
                                    isListLoading ? 
                                        <div className="mt-[80px] text-center">
                                            <Loading className="!pb-[5px]"/>
                                            <p>Loading, please wait...</p>
                                        </div>
                                    : 
                                    searchList?.length ? 
                                    <>
                                        <div className="mt-[20px] pb-[15px] grow overflow-y-auto px-[5px] " ref={listElement}>
                                            <div className="grid grid-cols-5 gap-[20px] mt-[10px]">
                                                {
                                                    searchList && searchList.map((product: ProductLib) => (
                                                        <div key={product.productId}>
                                                            <div className={`cursor-pointer`}  onClick={(e) => { e.stopPropagation(); changeProduct(product)}}>
                                                                <div className="aspect-square flex items-center justify-center]">
                                                                    <CustomImage loading="lazy" src={product.url || "/no-image.png"} className={`w-full h-full rounded-[10px]`} />
                                                                </div>
                                                                {
                                                                    <div className="flex items-center py-[10px]" >
                                                                        <span className="truncate small-txt" title={product.name}>{product.name}</span>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            {
                                                page && 
                                                <div className="mt-[30px] flex gap-[10px] items-center justify-center">
                                                    {
                                                        <span className={`w-[40px] h-[40px] flex items-center justify-center rounded-[10px] border  border-[#D9D9D9] ${ searchForm.currentPage > 1 ? 'hover:bg-[#E7F7FF] hover:border-[#FFFFFF]' : ''} cursor-pointer small-txt`}
                                                            onClick={() => contolerPage(searchForm.currentPage - 1)}>
                                                            <CustomImage src={searchForm.currentPage > 1 ? "/icon/icon-layer-right.png" : "/icon/icon-layer-right-disabled.png"} className="rotate-[180deg] w-[26px] h-[26px] cursor-pointer" />
                                                        </span>
                                                    }
                                                    {
                                                        page.total > 0 &&
                                                        <span className={` w-[40px] h-[40px] flex items-center justify-center rounded-[10px]  hover:border-[#FFFFFF]  hover:bg-[#E7F7FF] cursor-pointer small-txt ${page.current === 1 && 'bg-[#E7F7FF]' || 'border border-[#D9D9D9]'}`}
                                                            onClick={() => contolerPage(1)}>{1}</span>
                                                    }
                                                    
                                                    {
                                                        page.isLeftMore && <span className=" w-[40px] h-[40px] flex items-center justify-center  small-txt">...</span> 
                                                    }
                                                    {
                                                        
                                                        Array.from({ length: Math.min(Math.abs(page.total - 2), 5) }, (_, index: number) => {
                                                            const startIndex = Math.max(2, (page.current - 2 - (page.total - page.current < 2 ? 1 : 0 ))) + index ;
                                                            if(startIndex >= page.total || startIndex <= 1 || Math.abs(startIndex - page.current) > 3) return null ;

                                                            return <span key={startIndex} className={` w-[40px] h-[40px] flex items-center justify-center rounded-[10px] hover:border-[#FFFFFF]  hover:bg-[#E7F7FF] cursor-pointer small-txt ${page.current === startIndex && 'bg-[#E7F7FF]' || 'border border-[#D9D9D9]'}`}
                                                                onClick={() => contolerPage(startIndex)}>{startIndex}</span>
                                                        })
                                                    }
                                                    {
                                                        page.isRightMore && <span className=" w-[40px] h-[40px] flex items-center justify-center  small-txt">...</span> 
                                                    }
                                                    {
                                                        page.total > 1 &&
                                                        <span className={` w-[40px] h-[40px] flex items-center justify-center rounded-[10px]  hover:border-[#FFFFFF]  hover:bg-[#E7F7FF] cursor-pointer small-txt ${page.current === page.total && 'bg-[#E7F7FF]' || 'border border-[#D9D9D9]'}`}
                                                            onClick={() => contolerPage(page.total)}>{page.total}</span>
                                                    }
                                                    {
                                                        <span className={`w-[40px] h-[40px] flex items-center justify-center rounded-[10px] border  border-[#D9D9D9] ${ searchForm.currentPage < page.total ? 'hover:bg-[#E7F7FF] hover:border-[#FFFFFF]' : ''} cursor-pointer small-txt`}
                                                            onClick={() => contolerPage(searchForm.currentPage + 1)}>
                                                            <CustomImage  src={searchForm.currentPage < page.total ? "/icon/icon-layer-right.png" : "/icon/icon-layer-right-disabled.png"} className="w-[26px] h-[26px] cursor-pointer" />
                                                        </span>
                                                    }
                                                </div>
                                            }
                                        </div>
                                        
                                    </>
                                    :
                                    <div className="text-center mt-[10%] flex flex-col justify-center items-center">
                                        <CustomImage src="/icon/icon-empty.png" className="w-[300px]" />
                                        <p className="text-[#BFBFBF] font-semibold text-[16px] xl:text-[20px]">No matching resources</p>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                : null
            }
        </div>
    )
}

type ProductTypeLib = {
    id : string,
    name: string,
    url : string,
    sonList ?: ProductTypeLib[]
}

type ProductLib = {
    productId : string,
    name: string,
    url : string,
}

type Item = {
    value: string,
    name: string
}

type Page = {
    total : number,
    current : number,
    isLeftMore : boolean,
    isRightMore : boolean
}

type SearchForm = {
    keyword ?: string,
    id : string,
    tags ?: string[],
    pageSize : number,
    currentPage : number
}

type SonTypeScroll = {
    isShow : boolean,
    isAllowNext ?: boolean,
    isAllowPrev ?: boolean,
    page : number,
    totalPage ?: number
}

type Tag = {
    title: string,
    isShow ?: boolean,
    list : TagItem[]
}

type TagItem = {
    value : string,
    name: string
}


const ClothTags : Tag[] = [{
    title: 'Gender',
    isShow: false,
    list : [{
        value: '',
        name: 'All'
    },{
        value: 'men',
        name: 'Men'
    },{
        value: 'women',
        name: 'Women'
    }]
}]

const ProductTags : Tag[]  = [{
    title: 'Style',
    isShow: false,
    list: [{
        value: '',
        name: 'All'
    },{
        value: 'model-shot',
        name: 'Model Shot'
    },{
        value: 'product-only',
        name: 'Product Only'
    }]
}]


const SceneList : Tag = {
    title: 'Scene',
    isShow: false,
    list : [{
        value: '',
        name: 'All'
    },{
        value: 'lifestyle',
        name: 'Lifestyle'
    },{
        value: 'white-background',
        name: 'White Background'
    }]
}

ClothTags.push(SceneList);
ProductTags.push(SceneList)